/**
 * Tek Başına Oyna'nın son seçilen türü. Tekrar girince oyuncu kaldığı moddan
 * devam etsin diye tarayıcıda saklanır.
 */

export type SoloMode = "classic" | "timed";

const STORAGE_KEY = "mk.solo.mode";

export function parseSoloMode(raw: string | null): SoloMode {
  return raw === "timed" ? "timed" : "classic";
}

export function loadSoloMode(): SoloMode {
  try {
    return parseSoloMode(window.localStorage.getItem(STORAGE_KEY));
  } catch {
    return "classic";
  }
}

export function saveSoloMode(mode: SoloMode): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    /* Depo kapalıysa yalnızca hatırlanmaz. */
  }
}

/**
 * 3 dakika hesap ve bağlantı ister. Saklanan tercih "timed" olsa da oyuncu
 * çevrimdışıysa ya da çıkış yaptıysa açılış klasik moda düşer — Tek Başına
 * Oyna'nın çevrimdışı çalışma sözü bozulmasın. Oturum henüz yükleniyorsa karar
 * beklenir.
 */
export function resolveSoloMode(
  stored: SoloMode,
  session: "loading" | "authed" | "anon",
  online: boolean,
): SoloMode {
  if (stored !== "timed") return "classic";
  if (!online || session === "anon") return "classic";
  return "timed";
}
